import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { Direction } from "../../core/model/direction";
import { DirectionService } from "../../core/service/direction.service";

@Component({
  selector: "app-add-direction",
  templateUrl: "./add-direction.component.html",
  styleUrls: ["./add-direction.component.scss"],
})
export class AddDirectionComponent implements OnInit {
  direction: Direction = new Direction();

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _directionService: DirectionService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.pressButton = true;
    this._directionService
      .postDirection(this.direction)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
